export const mutation_add_metering_consumption = `
mutation addMeteringConsumption($tenantId: String!, $companyName: String!, $companyId: Int!) {
    addMeteringConsumption(tenantId: $tenantId, companyName: $companyName, companyId: $companyId) {
        value
    }
}`;
export const mutation_read_metering_consumption = `
mutation readMeteringConsumption($tenantId: String!) {
    readMeteringConsumption(tenantId: $tenantId) {
        packageId
        availableSlots
        usedSlots
        lockedSlots
        coolDownSlots
        remainingSlots
    }
}`;